export const API_ENDPOINT = 'https://api.bladminlogin.com';